import { render } from "./DairyGoatSheepDataForm.vue?vue&type=template&id=4b1b9ec0&scoped=true&ts=true"
import script from "./DairyGoatSheepDataForm.vue?vue&type=script&lang=ts"
export * from "./DairyGoatSheepDataForm.vue?vue&type=script&lang=ts"

import "./DairyGoatSheepDataForm.vue?vue&type=style&index=0&id=4b1b9ec0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b1b9ec0"]])

export default __exports__